/* eslint-disable @typescript-eslint/no-magic-numbers */
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/core';
import { SentryUtil } from '@app/shared/utils/sentry.util';
import metadata from '@assets/phone.metadata.json';

export const SUPPORTED_COUNTRY_CALLING_CODES = [
  'AC',
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TA',
  'TC',
  'TD',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'XK',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
];

// IBAN length and structure per country
const IBANLENGTHS: { [country: string]: number } = {
  AL: 4,
  AD: 24,
  AT: 20,
  AZ: 28,
  BH: 22,
  BE: 16,
  BA: 20,
  BR: 29,
  BG: 22,
  CR: 22,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  DO: 28,
  EE: 20,
  FO: 18,
  FI: 18,
  FR: 27,
  GE: 22,
  DE: 22,
  GI: 23,
  GR: 27,
  GL: 18,
  GT: 28,
  HU: 28,
  IS: 26,
  IE: 22,
  IL: 23,
  IT: 27,
  JO: 30,
  KZ: 20,
  KW: 30,
  LV: 21,
  LB: 28,
  LI: 21,
  LT: 20,
  LU: 20,
  MK: 19,
  MT: 31,
  MR: 27,
  MU: 30,
  MD: 24,
  MC: 27,
  ME: 22,
  NL: 18,
  NO: 15,
  PK: 24,
  PS: 29,
  PL: 28,
  PT: 25,
  QA: 29,
  RO: 24,
  SM: 27,
  SA: 24,
  RS: 22,
  SK: 24,
  SI: 19,
  ES: 24,
  SE: 24,
  CH: 21,
  TN: 24,
  TR: 26,
  AE: 23,
  GB: 22,
  VG: 24,
  DZ: 24,
  AO: 25,
  BJ: 28,
  BF: 27,
  BI: 16,
  CM: 27,
  CV: 25,
  CF: 27,
  TD: 27,
  KM: 27,
  CG: 27,
  EG: 27,
  GA: 27,
  GW: 25,
  HN: 28,
  IR: 26,
  CI: 28,
  MG: 27,
  ML: 28,
  MA: 24,
  MZ: 25,
  NI: 32,
  NE: 28,
  SN: 28,
  TG: 28,
};

export const isCountryCallingCodeSupported = (code?: string | null): boolean =>
  SUPPORTED_COUNTRY_CALLING_CODES.includes(`${code || ''}`.toUpperCase());

export interface ParsedPhoneMetadata {
  country: string;
  countryCode: string;
  areaCode: string;
  national: string;
  display: string;
}

export const popsyCheckPhone = (phone: string, country?: CountryCode | null): boolean => {
  if (!phone) {
    return false;
  }

  try {
    // Metadata only for Brasil / Saudi Arabia (use script in `package.json` to add more countries
    // and then set country here dinamically for validation)
    const phoneNumber = parsePhoneNumber(phone, country || 'BR', metadata as any);
    return phoneNumber.isValid() || phoneNumber.isPossible();
  } catch (error) {
    if (
      error &&
      (error as any)?.message !== 'NOT_A_NUMBER' &&
      (error as any)?.message !== 'TOO_SHORT' &&
      (error as any)?.message !== 'TOO_LONG' &&
      (error as any)?.message !== 'INVALID_COUNTRY'
    ) {
      SentryUtil.reportException(error, false);
    }
    return false;
  }
};

export const popsyCheckPhoneCountry = (
  phone: string,
  country?: CountryCode | null
): boolean => {
  if (!phone) {
    return false;
  }
  try {
    // Metadata only for Brasil / Saudi Arabia (use script in `package.json` to add more countries
    // and then set country here dinamically for validation)
    parsePhoneNumber(phone, country || 'BR', metadata as any);
    return true;
  } catch (error) {
    if (error && (error as any)?.message === 'INVALID_COUNTRY') {
      return false;
    }

    return true;
  }
};

// Parses phones available at libphonenumber-js
// if not available returns null
export const popsyParsePhone = (
  phone: string,
  country?: CountryCode | null
): ParsedPhoneMetadata | null => {
  if (!phone) {
    return null;
  }

  try {
    // Metadata only for Brasil / Saudi Arabia (use script in `package.json` to add more countries
    // and then set country here dinamically for validation)
    const phoneNumber = parsePhoneNumber(phone, country || 'SA', metadata as any);
    if (phoneNumber) {
      let extension = `${phoneNumber.ext || ''}`;
      if (!extension && phoneNumber.country === 'BR') {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        extension = `${phoneNumber.nationalNumber || ''}`.slice(0, 2);
      }

      // remove initial 0 from national number
      if (phoneNumber.nationalNumber[0] === '0') {
        phoneNumber.nationalNumber = phoneNumber.nationalNumber.slice(1);
      }
      const localNumber = `${phoneNumber.nationalNumber || ''}`.slice(extension.length);

      let formattedLocalNumber = phoneNumber.formatNational();
      if (formattedLocalNumber[0] === '0') {
        // remove initial 0 from formatted number
        formattedLocalNumber = formattedLocalNumber.slice(1);
      }

      return {
        country: `${phoneNumber.country}`,
        countryCode: `${phoneNumber.countryCallingCode}`,
        areaCode: `${extension}`,
        national: `${localNumber}`,
        display: phoneNumber
          ? `+${phoneNumber.countryCallingCode || '1'} ${formattedLocalNumber || ''}`
          : '',
      };
    } else {
      return null;
    }
  } catch (error) {
    if (
      error &&
      (error as any)?.message !== 'NOT_A_NUMBER' &&
      (error as any)?.message !== 'TOO_SHORT' &&
      (error as any)?.message !== 'TOO_LONG' &&
      (error as any)?.message !== 'INVALID_COUNTRY'
    ) {
      SentryUtil.reportException(error, false);
    }
    return null;
  }
};

// Parses any phone whether is available at libphonenumber-js or not
export const popsyParseAnyPhone = (
  countryCode: string,
  phone: string,
  country?: CountryCode | null
): ParsedPhoneMetadata | null => {
  if (!phone || !countryCode) {
    return null;
  }

  try {
    // Metadata only for Brasil / Saudi Arabia (use script in `package.json` to add more countries
    // and then set country here dinamically for validation)
    const phoneNumber = parsePhoneNumber(
      `${countryCode}${phone}`,
      country || 'BR',
      metadata as any
    );
    if (phoneNumber) {
      let extension = `${phoneNumber.ext || ''}`;
      if (!extension && phoneNumber.country === 'BR') {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        extension = `${phoneNumber.nationalNumber || ''}`.slice(0, 2);
      }

      // remove initial 0 from national number
      if (phoneNumber.nationalNumber[0] === '0') {
        phoneNumber.nationalNumber = phoneNumber.nationalNumber.slice(1);
      }

      const localNumber = `${phoneNumber.nationalNumber || ''}`.slice(extension.length);

      let formattedLocalNumber = phoneNumber.formatNational();
      if (formattedLocalNumber[0] === '0') {
        // remove initial 0 from formatted number
        formattedLocalNumber = formattedLocalNumber.slice(1);
      }

      return {
        country: `${phoneNumber.country}`,
        countryCode: `${phoneNumber.countryCallingCode}`,
        areaCode: `${extension}`,
        national: `${localNumber}`,
        display: phoneNumber
          ? `+${phoneNumber.countryCallingCode || '1'} ${formattedLocalNumber || ''}`
          : '',
      };
    } else {
      return null;
    }
  } catch (error) {
    if (error && (error as any)?.message === 'INVALID_COUNTRY') {
      return {
        country: `${country}`,
        countryCode: `${countryCode}`,
        areaCode: ``,
        national: `${phone}`,
        display: `+${countryCode} ${phone || ''}` || '',
      };
    }
    return null;
  }
};

export const validateIBAN = (iban: string): boolean => {
  // Remove spaces and convert to uppercase
  iban = iban.replace(/\s+/g, '').toUpperCase();

  // Check if IBAN length is correct for the country
  const countryCode = iban.slice(0, 2);
  const expectedLength = IBANLENGTHS[countryCode];
  if (!expectedLength || iban.length !== expectedLength) {
    console.error(`IBAN length is incorrect for country ${countryCode}`);
    return false;
  } // for now we only check the length
  else {
    console.log(`IBAN length is correct for country ${countryCode}`);
    return true;
  }

  // Move the first four characters to the end of the string
  const rearrangedIban = iban.slice(4) + iban.slice(0, 4);

  // Replace each letter in the string with two digits
  const ibanNumeric = rearrangedIban.replace(/[A-Z]/g, (char: string) =>
    (char.charCodeAt(0) - 55).toString()
  );

  // Perform modulo-97 operation
  let remainder = ibanNumeric;
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9); // Process in 9-digit blocks for accuracy
    remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
  }
  return parseInt(remainder, 10) % 97 === 1;
};
